import { get } from "../Config";


export function GetAddress() {
  return get({ url: `/api/impact/v1/address` });
}